export const sitesWebMisc = {
  // NombreEditable.vue — inline-editable website name field
  ne: {
    aria: "Nazwa strony internetowej",
    placeholder: "Mój obiekt",
    hint: "Enter, aby zapisać · Esc, aby anulować",
  },

  // website/index.vue — website creation wizard
  website: {
    next: "Dalej",
  },

  // Notificaciones/index.vue — notifications timeline
  notif: {
    title: "Powiadomienia",
    subtitle: "Wszystko, co wydarzyło się w Państwa obiektach, w porządku chronologicznym.",
    // Filters
    filterAll: "Wszystkie",
    filterBookings: "Rezerwacje",
    filterCheckins: "Check-iny",
    filterServices: "Usługi",
    filterPayments: "Płatności",
    // Empty state
    emptyAll: "Brak powiadomień",
    emptyFilter: "Brak powiadomień w tym filtrze",
    emptyBody:
      "Gdy coś wydarzy się w Państwa rezerwacjach (nowa rezerwacja, check-in, płatność), pojawi się tutaj.",
    // Day separators
    noDate: "Bez daty",
    today: "Dziś",
    yesterday: "Wczoraj",
    // Event status (left column)
    stNueva: "Nowa",
    stActualizada: "Zaktualizowana",
    stCancelada: "Anulowana",
    stRealizado: "Zrealizowane",
    stSolicitado: "Zamówione",
    stRecibida: "Otrzymana",
    stAprobada: "Zatwierdzona",
    stRechazada: "Odrzucona",
    stConfirmado: "Potwierdzone",
    stEnProceso: "Płatność w toku",
    stAviso: "Powiadomienie",
    // Event category (subtitle)
    catReserva: "rezerwacja",
    catCheckin: "check-in",
    catServicio: "usługa",
    catSolicitud: "zgłoszenie",
    catPago: "płatność",
    catPagoPendiente: "płatność oczekująca",
    catSistema: "system",
    // Descriptive event-type labels
    lbNuevaReserva: "Nowa rezerwacja",
    lbReservaActualizada: "Rezerwacja zaktualizowana",
    lbReservaCancelada: "Rezerwacja anulowana",
    lbCheckin: "Check-in",
    lbServicio: "Usługa",
    lbSolicitud: "Zgłoszenie",
    lbSolicitudAprobada: "Zgłoszenie zatwierdzone",
    lbSolicitudRechazada: "Zgłoszenie odrzucone",
    lbPago: "Płatność",
    lbNotificacion: "Powiadomienie",
  },

  // Integrations/index.vue — integrations with external services
  integrations: {
    title: "Integracje",
    subtitle: "Połącz usługi zewnętrzne, aby usprawnić zarządzanie",
    descPricelabs: "Dynamiczna optymalizacja cen",
    descStripe: "Płatności kartą od gości",
    descWompi: "Płatności gości w Kolumbii",
    connected: "Połączono",
    disconnected: "Nie połączono",
  },
};
